import { render, staticRenderFns } from "./MonographyCard.vue?vue&type=template&id=3e04d686&scoped=true"
import script from "./MonographyCard.vue?vue&type=script&lang=js"
export * from "./MonographyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e04d686",
  null
  
)

export default component.exports